import { editStorageObject } from "../../../../../app/state/storageObjectSlice/actions/actions";
import { setResearchValue } from "../../../../../features/ResearchService/redux/slice";
import { ResearchValue } from "../../../../api/instances/researchApi/types";
import { ServiceHandler } from "./storageHandlers";

export const ResearchService: ServiceHandler = {
  async onCreate(listenerApi, normalized, meta) {
    if (normalized.value === null) {
      return;
    }
    try {
      const updatedValue: ResearchValue = {
        research_object: {
          result: null,
          event_log: null,
          run_id: null,
        },
      };
      await listenerApi.dispatch(
        editStorageObject({
          id: normalized.id,
          name: normalized.friendly_name,
          value: updatedValue,
          service: meta.arg.service,
          skipUpdateListener: true,
        })
      );
      listenerApi.dispatch(setResearchValue(updatedValue));
    } catch (e) {
      console.error("Ошибка при создании объекта исследования", e);
    }
  },
  async onSelect(listenerApi, id, value) {
    if (id === null || value === null) return;
    const researchValue = value as ResearchValue;
    try {
      listenerApi.dispatch(setResearchValue(researchValue));
    } catch (e) {
      console.error("Нет объекта с таким ID");
    }
  },
};
